import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormType, FormAssignment } from '../../models/form-assignment';
import { User } from '../../models/user/user';

@Component({
  selector: 'app-form-assignment-dialog',
  templateUrl: './form-assignment-dialog.component.html',
  styles: [`
    :host {
      display: block;
    }

    .form-dialog {
      padding: 24px;
      max-width: 100%;
      overflow: hidden;
    }

    .dialog-title {
      color: #2d3748;
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 16px;
      border-bottom: 1px solid #e2e8f0;
    }

    .close-icon {
      color: #718096;
      cursor: pointer;
      padding: 8px;
      margin: -8px;
      transition: color 0.2s;
    }

    .close-icon:hover {
      color: #2d3748;
    }

    .dialog-content {
      margin: 0;
      padding: 0;
      overflow: visible;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .field-label {
      font-size: 14px;
      font-weight: 500;
      color: #4a5568;
      margin-bottom: 8px;
      display: block;
    }

    .field-input {
      width: 100%;
    }

    .custome_group_wrapper {
      position: relative;
      margin-bottom: 4px;
    }

    :host ::ng-deep .frm-ng-select {
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      min-height: 40px !important;
      background: #fff;
    }

    :host ::ng-deep .ng-value {
      font-weight: 400;
      font-size: 14px;
    }

    
    :host ::ng-deep .ng-option {
      font-weight: 400;
      font-size: 14px !important;
    }

    :host ::ng-deep .frm-ng-select .ng-select-container {
      min-height: 40px !important;
    }

    :host ::ng-deep .new-frm-input {
      width: 100%;
    }

    :host ::ng-deep .mat-form-field-appearance-none .mat-form-field-wrapper {
      margin: 0;
      padding: 0;
    }

    :host ::ng-deep .mat-form-field-flex {
      border: 1px solid #e2e8f0 !important;
      border-radius: 6px !important;
      padding: 0 12px !important;
      height: 40px !important;
      align-items: center !important;
      background: #fff !important;
    }

    :host ::ng-deep .mat-form-field-appearance-none .mat-form-field-underline {
      display: none;
    }

    .error {
      color: #e53e3e;
      font-size: 12px;
      margin-top: 4px;
    }

    .dialog-actions {
      margin: 32px -24px -24px;
      padding: 16px 24px;
      background: #f7fafc;
      border-top: 1px solid #e2e8f0;
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }

    .btn-secondary {
      height: 40px;
      padding: 0 16px;
      border: 1px solid #e2e8f0;
      background: white;
      color: #4a5568;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
    }

    .btn-secondary:hover {
      background: #f7fafc;
      border-color: #cbd5e0;
    }

    .btn-publish {
      height: 40px;
      padding: 0 16px;
      border: none;
      background: #4299e1;
      color: white;
      border-radius: 6px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;
    }

    .btn-publish:hover {
      background: #3182ce;
    }

    .btn-publish:disabled {
      background: #cbd5e0;
      cursor: not-allowed;
    }
  `]
})
export class FormAssignmentDialogComponent {
  form: FormGroup;
  
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FormAssignmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      invoiceId: string;
      formTypes: any[];
      users: User[];
    }
  ) {
    this.form = this.fb.group({
      formType: ['', Validators.required],
      assignedTo: ['', Validators.required],
      dueDate: ['']
    });
  }

  onSubmit() {
    if (this.form.valid) {
      const assignment: FormAssignment = {
        invoiceId: this.data.invoiceId,
        ...this.form.value
      };
      this.dialogRef.close(assignment);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
